module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amo":{"entity":{"name":{"lead":"Lead","contact":"Contact"}}}},"ua":{"amo":{"entity":{"name":{"lead":"Угода","contact":"Контакт"}}}},"ru":{"amo":{"entity":{"name":{"lead":"Сделка","contact":"Контакт"}}}}}')
  delete Component.options._Ctor
}
